// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC1-m62CZbXkGxyknAvowkBKQXYCBYNEF0",
  authDomain: "netflixgpt-1dce1.firebaseapp.com",
  projectId: "netflixgpt-1dce1",
  storageBucket: "netflixgpt-1dce1.firebasestorage.app",
  messagingSenderId: "858484801600",
  appId: "1:858484801600:web:3727185008f2c104349fa5",
  measurementId: "G-T9Q0H5EKZE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth();

export const auth_bearer =
  "Bearer "+process.env.REACT_APP_TMDB_API;

export const GEMINI_API = process.env.REACT_APP_GEMINI_API;
